import React from 'react';

export const PlusIcon = ({ className, size = 20 }) => <svg
    className={className}
    viewBox="0 0 24 24"
    height={size}
    width={size}
    xmlns="https://www.w3.org/2000/svg"
  >
    <path d="M23.6668 13.6667H13.6668V23.6667H10.3335V13.6667H0.333496V10.3333H10.3335V0.333344H13.6668V10.3333H23.6668V13.6667Z" />
  </svg>

export default PlusIcon;
